import React from "react";
import { useQuery } from "react-admin";
import { Chip } from "@material-ui/core";

const WebhookTriggerChips = ({ record }) => {
  let alerts = [];
  if (!record.AlertTypes) {
    const { data, loading, error } = useQuery({
      type: "getOne",
      resource: "Webhooks",
      payload: { id: record.id },
    });

    if (loading) return <span>Loading...</span>;
    if (error) return <span>Error: {error.message}</span>;
    if (!data) return null;
    if (!data.AlertTypes) return <span>No Alert Types</span>;
    return renderChips(data.AlertTypes);
  } else {
    alerts = record.AlertTypes;
    return renderChips(alerts);
  }
};

function renderChips(alerts) {
  return alerts.map((alert) => (
    <Chip key={alert.id} label={alert.event_type} style={{ margin: 2 }} />
  ));
}

export default WebhookTriggerChips;
